import { render, staticRenderFns } from "./ThankYouNoFee.vue?vue&type=template&id=508e4bc7&"
import script from "./ThankYouNoFee.vue?vue&type=script&lang=js&"
export * from "./ThankYouNoFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports